

	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { RelationByYear, Subject } from '@shared/models';
	import ProItem from '@client/views/industry/pros/ProItem.vue';

	@Component({
		components: {
			ProItem,
		},
	})
	export default class ProCompanyTimeline extends BaseView {


		public modelId: string;
		public list: RelationByYear[] = [];

		/** Fires when this view is mounted */
		public async mounted() {
			await this.refresh();
		}

		/** Refreshes the data displayed in this timeline */
		public async refresh() {
			this.loading = true;
			try {
				this.list = [];
				this.modelId = this.$route.params.id;
				const relations = await this.$api.relationService.proToCompanyRelations(this.modelId, true);

				// WE NEED TO FIND THE EARLIEST YEAR, AND THE LATEST YEAR TO GET THE RANGE FOR THIS TIMELINE
				let earliestYear = new Date().getFullYear();
				let latestYear = 0;
				for (const item of relations) {
					for (const timeFrame of item.timeFrame) {
						if (timeFrame.startYear < earliestYear) { earliestYear = timeFrame.startYear; }
						if (timeFrame.endYear > latestYear) { latestYear = timeFrame.endYear; }
					}
				}

				for (let year = earliestYear; year <= latestYear; year++) {
					// START BY CREATING THE GROUPING FOR THIS YEAR
					const group = new RelationByYear({ year, subjects: [] });

					// LOOP THROUGH ALL THE SUBJECTS AND FIND ALL OF THE ONES THAT FALL UNDER THIS YEAR
					for (const item of relations) {
						for (const timeframe of item.timeFrame) {
							if (timeframe.startYear <= year && timeframe.endYear >= year) {
								group.subjects.push(new Subject({ id: item.subject.id, name: item.subject.name }));
								break;
							}
						}
					}
					this.list.push(group);
				}
			} catch (err) {
				this.errorHandler.handle(err, 'An error occurred while loading this pros company timeline');
			} finally {
				this.loading = false;
			}
		}

		/** Fires when a broken image is detected and replaces it with the default stub image. */
		public handleBrokenImage($event: any) {
			$event.target.src = `${this.settings.baseUrl}/Assets/Stubs/default-company.jpg`;
		}


	}

